export const GET_SUBPARTNERS = gql`
    query GetPartnerOfPartners {
        partnerOfPartners {
            id
            firstName
            lastName
            partnerOfAccountNumber
            business {
                legalName
                id
                hierarchyLevel
                status
            }
            partner {
                business {
                    legalName
                }
            }
        }
    }
`;

export const GET_PARTNER_OF_PARTNERS_OF_USER = gql`
    query GetPartnerOfPartnersForUser {
        partnerOfPartnersForUser {
            id
            firstName
            lastName
            business {
                legalName
                id
            }
            partner {
                business {
                    legalName
                    id
                }
            }
        }
    }
`;

export const GET_PARTNER_OF_PARTNER = gql`
    query GetPartnerOfPartner($id: Int!) {
        partnerOfPartner(id: $id) {
            id
            firstName
            lastName
            logo
            countryDetails {
                currencies {
                    symbol
                }
            }
            business {
                legalName
                id
                hierarchyLevel
                hierarchyLevel
                businessType
                creditLimit
                currency
                language
                membershipNumber
                paymentTerms
                registeredNumber
                status
                taCode
                tradingName
                vatNumber
                vatValidatedAt
                website
                worldPayID
                businessTypeId
                accountManagerId
                merchantId
            }
            notes {
                id
                subject
                body
                createdAt
                createdById
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
            merchants {
                id
                status
                business {
                    id
                }
            }
            offer {
                id
                name
                type
                createdAt
            }
            contract
            telephoneNumber
            mobilePhoneNumber
            primaryContactInformation
            billingContactInformation
            serviceContactInformation
            bank {
                id
                bic
                iban
                sortCode
                accountNumber
            }
            partner {
                id
                business {
                    legalName
                }
            }
            transactionPricingOffers {
                id
                offerName
                createdAt
                status
            }
            services {
                terminalService {
                    merchantStatus
                    serviceType
                }
                onlineService {
                    merchantStatus
                    serviceType
                }
            }
            commission {
                id
                commissionType
                totalAmount
            }
        }
    }
`;
